import React from 'react';
import { NextPage } from 'next';
import { connect } from 'react-redux';

import api from 'api/jobs';
import rootActions from 'redux/rootActions';
import { JobsTop } from 'pages_data/vacatures';
import { JobInterface } from 'types/jobOffer';
import { GetInitialProps } from 'types/getInitialProps';

import { ContentSection } from 'components/common/ContentSection';
import { JobsList } from 'components/jobs/JobsList';
import { TitleHeader } from 'components/header/TitleHeader';
import { TopSection } from 'components/common/TopSection';
import { JobItem } from 'components/jobs/JobItem';
import { Layout } from 'components/common/Layout';

interface Props {
    data: {
        [key: string]: JobInterface;
    };
    pathName: string;
}

const Jobs: NextPage<Props> = (props) => {
    const { data, pathName } = props;
    const jobs = data || {};

    if (Object.keys(jobs).length) {
        delete jobs['650'];
    }

    return (
        <Layout pathName={pathName}>
            <TitleHeader title="Vacatures" />
            <TopSection text={JobsTop.text} />
            <ContentSection>
                <JobsList>
                    {Object.values(jobs).map((job) => (
                        <JobItem key={job.id} {...job} />
                    ))}
                </JobsList>
            </ContentSection>
        </Layout>
    );
};

Jobs.getInitialProps = async (ctx: GetInitialProps): Promise<any> => {
    const { store } = ctx;

    if (store.getState().jobs.all) {
        return {
            pathName: ctx.pathname,
        };
    }

    return api.all({ limit: 24 }).then((payload) => {
        store.dispatch(rootActions.fetchJobsSuccess(payload));

        return {
            pathName: ctx.pathname,
        };
    });
};

export default connect((state) => {
    return {
        data: state.jobs.data,
    };
}, rootActions)(Jobs);
